import { motion } from 'framer-motion';
import { Globe2, Lock, ShieldCheck, Database } from 'lucide-react';
import { fadeUp, stagger } from './helpers';

export const TrustStrip = () => {
    const signals = [
        { icon: Globe2, label: 'UK-hosted (London region)' },
        { icon: Lock, label: 'Encryption at rest and in transit' },
        { icon: ShieldCheck, label: 'DPA + GDPR compliant' },
        { icon: Database, label: '30-day deletion on request' },
        { icon: ShieldCheck, label: 'Cyber Essentials · SOC 2 Type I Q4 2026' },
    ];

    return (
        <section className="py-10 border-y border-border/40 bg-muted/20">
            <div className="max-w-6xl mx-auto px-6">
                <p className="text-center text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-5 font-semibold">Built for the security expectations of UK and EU tech buyers</p>
                <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="flex flex-wrap justify-center gap-x-9 gap-y-3">
                    {signals.map(({ icon: Icon, label }) => (
                        <motion.div key={label} variants={fadeUp} className="flex items-center gap-2 text-muted-foreground text-sm">
                            <Icon className="h-3.5 w-3.5" />
                            <span>{label}</span>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};
